// Переключатель темы рядом с валютным бейджем: обе штуки про то, как
// приложение выглядит, и жить им логично вместе.
//
// Порядок по кругу — тёмная → светлая → по системе. «По системе» последним
// намеренно: это не третий вкус, а отказ от выбора, и предлагать его первым
// значит прятать за ним две настоящие темы.

import { useEffect, useState } from 'react';
import { applyTelegramTheme, haptic } from '../lib/telegram';
import { type ThemePref, loadThemePref, saveThemePref, systemScheme } from '../lib/theme';
import { MonitorIcon, MoonIcon, SunIcon } from './icons';

const ORDER: ThemePref[] = ['dark', 'light', 'system'];

const LABEL: Record<ThemePref, string> = {
  dark: 'Тёмная тема',
  light: 'Светлая тема',
  system: 'Как в системе',
};

export function ThemeToggle(): JSX.Element {
  const [pref, setPref] = useState<ThemePref>(loadThemePref);

  // «По системе» должна следовать за системой и после того, как её выбрали:
  // иначе смена оформления телефона оставит приложение в прежнем виде.
  useEffect(() => {
    if (pref !== 'system') return;
    const mq = matchMedia('(prefers-color-scheme: light)');
    const onChange = (): void => {
      applyTelegramTheme('system');
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [pref]);

  const next = (): void => {
    const idx = ORDER.indexOf(pref);
    const value = ORDER[(idx + 1) % ORDER.length] ?? 'dark';
    haptic('light');
    setPref(value);
    saveThemePref(value);
    applyTelegramTheme(value);
  };

  const Icon = pref === 'dark' ? MoonIcon : pref === 'light' ? SunIcon : MonitorIcon;
  const shown =
    pref === 'system'
      ? `Как в системе (${systemScheme() === 'light' ? 'светлая' : 'тёмная'})`
      : LABEL[pref];

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={next}
      aria-label={`${shown}. Нажмите, чтобы сменить`}
      title={shown}
    >
      <Icon size={15} />
    </button>
  );
}
